import { api } from "../api";

export type BundleStatus =
  | { kind: "probing" }
  | { kind: "available" }
  | { kind: "unavailable" }
  | { kind: "expired"; expiredAt: string | null };

interface Props {
  jobId: string;
  status: BundleStatus;
  /** When true, render compact (label "Bundle"). Used in the inspector header. */
  compact?: boolean;
}

export function EvidenceDownloadButton({ jobId, status, compact }: Props) {
  const label = compact ? "Bundle" : "Download evidence bundle";
  if (status.kind === "probing") {
    return (
      <button className="primary" disabled title="Checking availability…">
        {label}
      </button>
    );
  }
  if (status.kind === "available") {
    return (
      <a href={api.evidenceUrl(jobId)}>
        <button className="primary">{label}</button>
      </a>
    );
  }
  if (status.kind === "expired") {
    const date = status.expiredAt ? formatDate(status.expiredAt) : "the retention window";
    return (
      <button
        className="primary"
        disabled
        title={`Artifacts auto-deleted on ${date}. Re-submit the source video to regenerate.`}
      >
        {label}
      </button>
    );
  }
  // unavailable
  return (
    <button
      className="primary"
      disabled
      title="Evidence bundle wasn't generated for this job. Re-submit to generate one."
    >
      {label}
    </button>
  );
}

function formatDate(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
